var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title.isMonthDisplayed)?_c('h2',{staticClass:"SeparationTitle"},[_vm._v(_vm._s(_vm.title.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }